import React from "react";
import { Link, useLocation } from "react-router-dom";
import logoIHF from "../imgs/iury.png";

import "./Navbar.css";

export const Navbar = () => {
  let location = useLocation().pathname;
  let newLocation = location.slice(0, 16);
  console.log(newLocation);
  return (
    <>
      <nav className="nav-denuncia-client">
        <div className="container">
          <div className="top-name">
            <Link to="/">Canal de Denúncias - 1RIGO</Link>
          </div>
          <div className="logo">
            <img src={logoIHF} alt="Logotipo Iury" />
          </div>
          <ul className="nav justify-content-end">
            <li className="nav-item">
              <Link to="/" className="nav-link px-2 ">
                Início
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/complaints" className="nav-link px-2 ">
                Faça uma denúncia
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/track-complaint" className="nav-link px-2 ">
                Acompanhe sua denúncia
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      {newLocation !== "/track-complaint" ? (
        <div className=" back mb-3"></div>
      ) : null}
    </>
  );
};
